export const waitingRoom = {
  title: {
    visitCancelled: ' Your visit has been canceled.',
    weMissedYou: 'We’re sorry we missed you, {{ name }}!',
    visitExpired: 'Your visit link has expired.',
    teamNotified: '{{ name }}, you’re confirmed for our next available provider.',
    appointmentFinished: 'Thanks for trusting us with your care today, {{ name }}!',
    visitInProgress: 'Your consultation is in progress...',
    readyToSee: 'Your {{ medicalTeam }} is ready to see you, {{ name }}.',
    cancelVisit: 'Cancel Visit',
    offHours: '{{ name }}, your {{ medicalTeam }} will be available {{ day }} at {{ time }}.',
    preferredPharmacy: 'Your preferred pharmacy',
    nextStep: 'Your next step',
    makeChange: 'Need to make a change?',
    getReady: 'Let’s get ready for your visit {{ name }}.',
    oneTime: 'one-time',
    signThe: 'Sign the',
    signConsentForm: 'consent form that’ll set you up for all your future visits.',
  },
  subtitle: {
    closePage: 'Feel free to close this page.',
    sendYouLink: 'We’ll send you a new link via text and email.',
    linkNoLongerActive: 'This link is no longer active, but you can still schedule a new visit.',
    whenTeamIsReady:
      'We’ll send you a text and email when your {{ medicalTeam }} is ready. Feel free to close this page.',
    greatTalk:
      'We’ll send you a summary of your visit and next steps that you can access in your Next Level Medical app.',
    readyForVisit: '{{ provider }} is ready for your consultation!',
    reasonForCancel: 'What’s the reason for canceling?',
    offHours: 'We’ll send you a text and email at {{ time }}. Feel free to close this page.',
    weMessage: 'We’ll message you when your {{ medicalTeam }} is ready.',
    visit: 'visit',
    inLine: 'in line',
    noPharmacy: 'No pharmacy added yet.',
    medicalTeam: 'medical team',
  },
  label: {
    primeWl: 'Next Level Virtual Visit',
  },
  time: {
    today: 'today',
    tomorrow: 'tomorrow',
  },
  actions: {
    returnToHome: 'Return Home',
    updateOrCancel: 'Update or Cancel This Visit',
    cancel: 'Cancel',
    joinNow: 'Join Now',
    confirmAndCancel: 'Confirm & Cancel',
    cancelConsultation: 'Cancel Consultation',
    goHome: 'Go Home',
    updatePharmacy: 'Update Pharmacy',
    close: 'Close',
    scheduleForLater: 'Schedule for a later time',
    goBackHome: 'Go Back Home',
    addPharmacy: 'Add Pharmacy',
    signConsent: 'Sign Consent',
    rejoinVisit: 'Rejoin Visit',
  },
  errors: {
    failedToLoad: 'Failed to load waiting room',
    failedToLoadPharmacy: 'Failed to load preferred pharmacy',
    failedToCancelVisit: 'Failed to cancel visit',
    failedToFetchPatientsInLine: 'Failed to fetch patients waiting in line',
    noSlotsFound: 'No free slots available',
  },
};
